import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaTruck, FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  // Try to load logo image, fallback to icon if not found
  const logoJpgPath = '/images/logo.jpg';
  const logoPngPath = '/images/logo.png';
  const logoSvgPath = '/images/logo.svg';
  const [logoSrc, setLogoSrc] = useState(null);

  useEffect(() => {
    // Check which logo format exists (check JPG first since it's the current format)
    const imgJpg = new Image();
    imgJpg.onload = () => setLogoSrc(logoJpgPath);
    imgJpg.onerror = () => {
      const imgPng = new Image();
      imgPng.onload = () => setLogoSrc(logoPngPath);
      imgPng.onerror = () => {
        const imgSvg = new Image();
        imgSvg.onload = () => setLogoSrc(logoSvgPath);
        imgSvg.onerror = () => setLogoSrc(null);
        imgSvg.src = logoSvgPath;
      };
      imgPng.src = logoPngPath;
    };
    imgJpg.src = logoJpgPath;
  }, []);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              {logoSrc ? (
                <img src={logoSrc} alt="V&R Courier Ltd Logo" className="footer-logo-img" />
              ) : (
                <FaTruck className="footer-logo-icon" />
              )}
              <span>V&R Courier Ltd</span>
            </div>
            <p className="footer-description">
              Professional and reliable logistics company providing nationwide and European delivery solutions. Operating 24/7 with a focus on customer satisfaction.
            </p>
            <div className="company-details">
              <p><strong>Company No:</strong> 15516419</p>
              <p><strong>VAT:</strong> 471529383</p>
            </div>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/track">Track Shipment</Link></li>
              <li><Link to="/quote">Get Quote</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Our Services</h3>
            <ul>
              <li><Link to="/services">Same Day Delivery</Link></li>
              <li><Link to="/services">Nationwide Collection & Delivery</Link></li>
              <li><Link to="/services">European Road Transport</Link></li>
              <li><Link to="/services">Multi-Drop Delivery</Link></li>
              <li><Link to="/services">House Moving & Removals</Link></li>
              <li><Link to="/services">Temperature Controlled Transport</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <ul className="contact-info">
              <li>
                <FaMapMarkerAlt />
                <span>
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Flex+Space+-+Unit+27+Roway+Lane+Oldbury+B69+3ES" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    Flex Space - Unit 27<br />Roway Lane, Oldbury<br />B69 3ES, UK
                  </a>
                </span>
              </li>
              <li>
                <FaPhone />
                <span>07502109790</span>
              </li>
              <li>
                <FaEnvelope />
                <span>info@vrcourier.co.uk</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} V&R Courier Ltd. All rights reserved. Company No: 15516419 | VAT: 471529383</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span>|</span>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

